<!-- Tableau -->
<div class="container-fluid">
  <div class="text-end mt-3" *appProfilePerimeter>
    <button type="button" class="btn btn-primary" *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY']" (click)="openModal()">
      Ajouter un contrat
    </button>
  </div>
  <div class="row mt-2">
    <div class="col px-0">
      <table class="table table-striped table-hover" aria-describedby="contractsTitle">
        <thead class="text-secondary bg-light">
          <tr>
            <th></th>
            <th scope="col" class="text-center" sortable="beginDate" (sort)="onSort($event)">Date de début</th>
            <th scope="col" class="text-center" sortable="endDate" (sort)="onSort($event)">Date de fin</th>
            <th scope="col" class="text-center" sortable="contractType" (sort)="onSort($event)">Type</th>
            <th scope="col" class="text-center" sortable="structure" (sort)="onSort($event)">Structure</th>
            <th scope="col" sortable="mainPurpose" (sort)="onSort($event)">Objectif principal</th>
            <th scope="col" class="text-center" sortable="status" (sort)="onSort($event)">Statut</th>
            <th scope="col" class="text-center" sortable="achievement" (sort)="onSort($event)">Atteinte</th>
          </tr>
        </thead>
        <tbody>
          @for (contract of contracts.items; track contract) {
            <tr (click)="openModal(contract.id)">
              <td></td>
              <td class="text-center">{{ contract.beginDate | date }}</td>
              <td class="text-center">{{ contract.endDate | date }}</td>
              <td class="text-center">{{ contract.contractType }}</td>
              <td class="text-center">{{ contract.structure }}</td>
              <td>{{ contract.mainPurpose }}</td>
              <td class="text-center">{{ contract.status }}</td>
              <td class="text-center">{{ achievements.get($achievement(contract.achievement)) }}</td>
            </tr>
          }
        </tbody>
      </table>
      @if (contracts.items.length === 0) {
        <p>Le bénéficiaire n'a aucun contrat.</p>
      }
    </div>
  </div>
  <div class="d-flex justify-content-between">
    <ngb-pagination
      [collectionSize]="contracts.totalItems"
      [page]="contracts.options.page"
      [pageSize]="contracts.options.limit"
      (pageChange)="changePage($event)"
    >
    </ngb-pagination>
    <select class="w-auto form-select" [ngModel]="contracts.options.limit" (change)="changeLimit($event)">
      <option [value]="10">10 éléments par page</option>
      <option [value]="25">25 éléments par page</option>
      <option [value]="50">50 éléments par page</option>
      <option [value]="100">100 éléments par page</option>
    </select>
  </div>
</div>
